import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';

const KPIS = ['WAC', 'UNITS', 'GROSS_SALES', 'LIABILITY', 'NET_SALES', 'GTN_PCT', 'DISC_PER_UNIT', 'ANSP'];

export const DemForecastProdPerspective = ({ forecastId }) => {
  const views = [
    {
      name: 'By Product',
      dims: ['FORECAST', 'PROD', 'PERIOD'],
      kpis: KPIS,
      dimToPeriodicities: {
        PERIOD: ['YEAR', 'QTR', 'MON'],
      },
      disabledDims: ['FORECAST'],
    },
    {
      name: 'By Period',
      dims: ['FORECAST', 'PERIOD', 'PROD'],
      kpis: KPIS,
      dimToPeriodicities: {
        PERIOD: ['YEAR', 'QTR', 'MON'],
      },
      disabledDims: ['FORECAST'],
    },
  ];

  const defaultDimFilters = { FORECAST: [forecastId] };

  return <EntityPerspective views={views} defaultDimFilters={defaultDimFilters} entity={'FORECAST_PROD'} />;
};
